import axios from 'axios';
import { Pharmacy } from '../models/pharmacy';

export const searchPharmacies = async (text: string): Promise<Undefinable<Pharmacy[]>> => {
    try {
        const response = await axios.get(`/api/pharmacy/search?text=${text}`);
        return response.data;
    } catch (e) {
        window.console.log(e);
        return [];
    }
};

export const getPharmacy = async (id: string): Promise<Undefinable<Pharmacy>> => {
    const response = await axios.get(`/api/pharmacy/${id}`);
    return response.data;
};
